import { render, staticRenderFns } from "./UserDetailsEditCard.vue?vue&type=template&id=c2ce1c68&"
import script from "./UserDetailsEditCard.vue?vue&type=script&lang=js&"
export * from "./UserDetailsEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports